export function Footer() {
  return (
    <footer className="hidden md:block border-t border-border px-6 py-4">
      <p className="text-center text-sm text-muted-foreground">
        Data from Roger Conrad&apos;s Utility Report Card. Always do your own research before
        making investment decisions.
      </p>
    </footer>
  );
}
